<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <v-dialog
      v-model="dialogCarteCaburant"
      max-width="70%"
      persistent
      fullscreen
      hide-overlay
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span> Liste des cartes carburant </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row>
            <v-card style="width:100%">
              <v-card-text fluid grid-list-md>
                <h6>LISTE DES CARTES</h6>
                <v-divider class="mb-3"></v-divider>

                <!-- BTN AJOUT -->
                <v-layout row>
                  <v-flex class="mb-1 " xs4 md4>
                    <v-card-text class="text-xs-center">
                      <v-chip
                        label
                        outline
                        color="orange darken-1"
                        class="elevation-4"
                        style="width:100%"
                      >
                        <span class="subheading">Solde Total: </span>
                        <span class="title"> {{ mntTotal }} Fcfa </span>
                      </v-chip>
                    </v-card-text>
                  </v-flex>

                  <v-flex class="mb-1 " xs4 md4>
                    <v-card-text class="">
                      <v-chip
                        color="orange"
                        text-color="white"
                        style="font-size:18px"
                      >
                        <v-avatar class="orange darken-4">{{
                          nbCarte
                        }}</v-avatar>
                        Carte(s)
                      </v-chip>
                    </v-card-text>
                  </v-flex>
                </v-layout>

                <div class="text-xs-right mb-3">
                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      icons
                      color="primary"
                      @click.stop="modalAjoutCarte()"
                      dark
                      >Ajouter une carte
                      <v-icon right>playlist_add</v-icon></v-btn
                    >
                    Effectuer une carte
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn
                      slot="activator"
                      color="orange"
                      :disabled="disabledBtnCarte"
                      @click.stop="imprimeDemandePDF()"
                      dark
                    >
                      Imprimer
                      <v-icon right> print</v-icon>
                    </v-btn>
                    Imprimer la liste des demandes
                  </v-tooltip>

                  <!-- <v-tooltip top>
                            <v-btn   slot="activator" color="orange"  @click.stop="imprimeDemandePDF()" dark>
                                Imprimer
                                <v-icon right > print</v-icon>
                            </v-btn>
                            Imprimer la liste des cartes
                        </v-tooltip> -->
                </div>

                <v-layout row> </v-layout>

                <div class="text-xs-left  mb-1 ">
                  <el-select
                    clearable
                    @clear="clearSelect()"
                    @change="filtrerSociete"
                    v-model="selectSoc"
                    placeholder="Trier par fournisseur"
                  >
                    <el-option
                      v-for="item in listeSociete"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>

                <data-tables :data="cartes">
                  <el-table-column prop="identifiant" label="Identifiant">
                    <template slot-scope="scope">
                      <el-tag> {{ scope.row.identifiant }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="libelle" label="Libelle">
                  </el-table-column>
                  <el-table-column
                    prop="station"
                    label="Fournisseur"
                  ></el-table-column>
                  <el-table-column prop="montantFormat" label="Solde (Fcfa)">
                    <template slot-scope="scope">
                      <el-tag> {{ scope.row.montantFormat }}</el-tag>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="nbReglement" label="Nb Règlement(s)" > </el-table-column> -->
                  <el-table-column prop="nbRecharge" label="Nb Appro">
                  </el-table-column>
                  <el-table-column label="Action" align="center" fixed="right">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="modalDetailCarte(scope.row)"
                          fab
                          dark
                          small
                          color="green"
                        >
                          <v-icon dark>folder_open</v-icon>
                        </v-btn>
                        Détails des opérations
                      </v-tooltip>
                      <!-- <v-tooltip top>
                                <v-btn  slot="activator"  @click="modalRgt(scope.row)" fab dark small color="green">
                                    <v-icon dark>account_balance_wallet</v-icon>
                                </v-btn>
                                Détails des règlements
                            </v-tooltip> -->

                      <!-- <v-tooltip top>
                                <v-btn  slot="activator" @click="modalTransfert(scope.row)"  fab dark small color="purple">
                                    <v-icon dark>cached</v-icon>
                                </v-btn>
                                Détail des transferts
                            </v-tooltip> -->

                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          @click.stop="modalEditCarte(scope.row)"
                          fab
                          dark
                          small
                          color="primary"
                        >
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                        Editer
                      </v-tooltip>

                      <v-tooltip top>
                        <v-btn
                          v-if="droitAcces.intervention"
                          slot="activator"
                          @click.stop="showDialogSupp(scope.row)"
                          fab
                          dark
                          small
                          color="red"
                        >
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                        Supprimer
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </data-tables>
              </v-card-text>
            </v-card>
          </v-layout>

          <!-- MODAL SUPPRESSION DEMANDE -->
          <v-dialog v-model="dialogSupr" persistent max-width="50%">
            <v-card>
              <v-card-title class="headline"
                >Supprimer cet enregistrement ?</v-card-title
              >
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 class="mb-2">
                    <el-alert
                      title="La suppression est définitive"
                      description="Tous les règlements effectués avec cette carte seront également supprimées,la suppresion ne sera pas possible si un rechargement a été effectué avec cette carte ."
                      :closable="false"
                      show-icon
                      type="warning"
                    >
                    </el-alert>
                  </v-flex>
                  <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">CARTE</p>
                    <p class="black--text .font-weight-regular subheading">
                      ID {{ carteId }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click="dialogSupr = false"
                  >Annuler <v-icon right>remove_circle</v-icon></v-btn
                >
                <v-btn color="red darken-1" dark @click="deleteCarte()"
                  >Supprimer <v-icon right>delete</v-icon></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- MODAL SUPPRESSION DEMANDE -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Ajout zone maintenance -->
    <AjoutCarteCarburant
      :editCarte="carteTransfert"
      :show="showModalAjoutCarte"
      @close="
        showModalAjoutCarte = false;
        loadCarte();
      "
    ></AjoutCarteCarburant>
    <!-- Ajout zone maintenance -->

    <!-- Liste des reglements d'une carte-->
    <ReglementCarteIndex
      :carte="carteRgt"
      :show="showModalRgt"
      @close="showModalRgt = false"
    ></ReglementCarteIndex>
    <!-- Liste des reglements d'une carte-->

    <!-- Liste des reglements d'une carte-->
    <TransfertCarteIndex
      :carte="carteTransfert"
      :show="showModalTransfert"
      @close="showModalTransfert = false"
    ></TransfertCarteIndex>
    <!-- Liste des reglements d'une carte-->

    <!-- Liste des details d'une carte-->
    <FicheDetailCarte
      :carte="carteSelect"
      :show="showModalDetail"
      @close="
        showModalDetail = false;
        loadCarte();
      "
    ></FicheDetailCarte>
    <!-- Liste des details d'une carte-->
  </div>
</template>

<script>
import ReglementCarteIndex from "./ReglementCarteIndex";
import TransfertCarteIndex from "./TransfertCarteIndex";
import AjoutCarteCarburant from "./AjoutCarteCarburant";
import FicheDetailCarte from "./FicheDetailCarte";

import Loading from "@/components/Loading";
export default {
  components: {
    Loading,
    AjoutCarteCarburant,
    ReglementCarteIndex,
    TransfertCarteIndex,
    FicheDetailCarte
  },
  name: "CarteCarburantIndex",
  props: ["show"],
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],
      cartes: [],
      disabledBtnCarte: false,
      oldCartes: [],
      dialogSupr: false,
      dialogCarteCaburant: false,
      selectSoc: "",
      listeSociete: [],
      showModalAjoutCarte: false,
      showModalRgt: false,
      nbCarte: 0,
      mntTotal: 0,
      carteRgt: {},
      carteId: null,
      carteSelect: {},

      //Rechargement
      carteTransfert: {},
      showModalTransfert: false,
      showModalTransfertCarte: false,

      //Detail
      showModalDetail: false
    };
  },

  watch: {
    show: function(newValue, oldValue) {
      this.dialogCarteCaburant = newValue;
      this.loadStation();
    }
  },

  methods: {
    showDialogSupp(item) {
      this.carteId = item.carteId;
      this.dialogSupr = true;
    },
    closeDialog() {
      this.$emit("close");
    },

    modalAjoutCarte() {
      this.carteTransfert = {};
      this.showModalAjoutCarte = true;
    },

    modalRgt(carte) {
      this.carteRgt = carte;
      this.showModalRgt = true;
    },

    modalDetailCarte(carte) {
      this.carteSelect = carte;
      this.showModalDetail = true;
    },

    modalTransfert(carte) {
      this.carteTransfert = carte;
      this.showModalTransfert = true;
    },
    loadStation() {
      let url = this.domaine + "carteCarburant/station/index";
      this.$http.get(url).then(
        response => {
          this.listeSociete = response.body.stations;
          //    this.cartes = response.body.stations
          this.nbCarteCar = response.body.nbCarteCar;
        },
        error => {
          //this.$message("Chargement de la liste des stations en cours")
        }
      );
    },

    imprimeDemandePDF() {
      let tab = [];
      this.cartes.forEach(function(carte) {
        tab.push(carte.carteId);
      });

      let url = this.domaine + "carteCarburant/imprimerPDF/liste/" + tab;
      window.open(url);
    },

    modalEditCarte(carte) {
      this.carteTransfert = carte;
      this.showModalAjoutCarte = true;
    },

    deleteCarte() {
      this.loading = true;
      let url = this.domaine + "carteCarburant/delete/carte/" + this.carteId;
      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION",
            message: response.body.message,
            type: "success",
            position: "top-center",
            duration: 10000
          });
          this.dialogSupr = false;

          this.loadCarte();
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression de la carte a échouée.",
            position: "top-center"
          });
        }
      );
    },

    clearSelect() {
      this.cartes = this.oldCartes;
    },

    filtrerSociete(idSoc) {
      this.loadCarteParStation(idSoc);
    },

    loadCarteParStation(idStation) {
      this.cartes = this.oldCartes;

      //this.selectSoc = null;
      this.cartes = this.cartes.filter(function(item) {
        return item.idStation == idStation;
      });
    },

    loadCarte() {
      this.loading = true;

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)

      let url = this.domaine + "carteCarburant/index";

      this.$http.get(url).then(
        response => {
          this.loading = false;

          // this.mntTTC =  response.body.mntTTC
          this.cartes = response.body.cartes;
          this.oldCartes = response.body.cartes;

          this.mntTotal = response.body.montantTotalFormat;
          //affichage nombre de demande
          this.nbCarte = this.cartes.length;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement des cartes"
          );
        }
      );
    }
  },

  mounted() {
    this.loadCarte();
  }
};
</script>

<style scoped>
.toolbar_content {
  height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/CarteCarburant_index.vue